export default "clock.9c88d95a87d77af6.png"